<template>
   <b-row class="payment-step">
      <b-col cols="12">
        <div class="modal-block-title" style="font-weight: 500;">I Have Sent Funds to Economix</div>
      </b-col>

      <b-col cols="12">
        <e-input type="number" step="0.1" min="0" floating label="Amount Sent" v-model="amount"></e-input>
        <e-input type="text" floating label="Transfer Refference Number [optional]" v-model="card"></e-input>
        <e-input type="text" floating label="Refference Document [optional]"></e-input>

        <e-hint title="REMINDER:">Final {{ orderData.asset.symbol }} amount you will receive will be according BTC rate at the time your payment is received at our bank</e-hint>        
      </b-col>

      <b-col cols="12">
        <div class="line">
          <p>By clicking the button above I agree and approve the <a href="#" @click.prevent="() => {}">Terms Of Use.</a></p>
          <e-button :disabled="disabledButton" @click="nextPage">Confirm</e-button>
        </div>
      </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "step-sent-money",
  components: { },
  data() {
    return {
      wallet: null,
      amount: 0,
      card: "0000 0000 0000 0000"
    };
  },
  methods: {
     ...mapActions("settings", ["setPaymentState"]),
     ...mapMutations("orders", ["setWalletId"]),
    nextPage() {
      this.$emit('nextPage');
    }
  },
   computed: {
    ...mapGetters("orders", {
      orderData: 'buyModalData'
    }),
    disabledButton() {
      return this.amount <= 0;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/buyCrypto/stepSentMoney.vue